"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.PostUploadNotificationTypes = exports.PreUploadNotificationTypes = void 0;
const _imports_1 = require("./_imports");
// @jendevelops TODO: add in slack notification
exports.PreUploadNotificationTypes = [
    _imports_1.Notifications.BorrowerEmailType.deliverablesResponsiblePartyReminder,
    _imports_1.Notifications.BorrowerEmailType.deliverablesResponsiblePartyStatusUpdate,
];
exports.PostUploadNotificationTypes = [
    _imports_1.Notifications.BorrowerEmailType.deliverablesResponsiblePartySubmitSubmission,
];
// Zod schemas for DeliverablePropertyDEPRECATED.Config
const PartyPermissionSchema = _imports_1.z.object({
    _id_: _imports_1.z.string(),
    permissionTypes: _imports_1.z.array(_imports_1.z.enum(_imports_1.Deliverable.v3DEPRECATED.PremissionTypes)),
});
const PreUploadNotificationProcessSchema = _imports_1.z.object({
    notificationType: _imports_1.z.enum(exports.PreUploadNotificationTypes),
    _config_: _imports_1.z.any().optional(),
});
const PostUploadNotificationProcessSchema = _imports_1.z.object({
    notificationType: _imports_1.z.enum(exports.PostUploadNotificationTypes),
    _config_: _imports_1.z.any().optional(),
});
exports.ConfigSchema = _imports_1.z.object({
    configKey: _imports_1.z.string(),
    deliverableType: _imports_1.z.nativeEnum(_imports_1.Deliverable.v3DEPRECATED.DeliverableType),
    frequency: _imports_1.z.enum(_imports_1.Utils.FrequencyPeriodIterable),
    dependencies: _imports_1.z.array(_imports_1.z.string()),
    partyPermissions: _imports_1.z.array(PartyPermissionSchema),
    preUploadNotificationProcesses: _imports_1.z.array(PreUploadNotificationProcessSchema),
    postUploadNotificationProcesses: _imports_1.z.array(PostUploadNotificationProcessSchema),
});
//# sourceMappingURL=DeliverablePropertyDEPRECATED.js.map